/** @format */

import React, {useContext} from 'react';
import {PRODUCT_TYPE_GRAPHIC_DESIGN} from 'frontier-constants';
import {prettyProductLabel} from 'frontier/ds/quoter/functions/format';
import SingleOrderSplitShipmentButton from 'frontier/cart/components/shipping/single_order_split_shipment_button';
import {CartCheckoutContext} from 'frontier/cart/components/cart/cart_checkout_context';
import {useSaveInput} from 'frontier/components/form/use_save_input';
import {Banner} from '@sttark/design-system';
import SingleShipmentJoinButton from 'frontier/cart/components/shipping/single_shipment_join_button';

/** @format */

export const SingleShipmenGraphicDesign = ({
    relatedShipmentIndex,
    toShipmentId,
    shipment,
    index
}) => {
    const ctx = useContext(CartCheckoutContext);

    const {
        saveInput: saveIsShippingBlind,
        isSaving: isShippingBlindSaving,
        error: isShippingBlindError
    } = useSaveInput(`/account/shipments/edit/${shipment.id}`, 'is_shipping_blind', 750);

    const shipmentOrderIds = shipment.designs_orders_shipments.reduce(
        (orderIds, {designs_order, ...stuff}) => {
            if (orderIds.indexOf(designs_order.order_id) === -1) {
                return [...orderIds, designs_order.order_id];
            }
            return orderIds;
        },
        []
    );

    return (
        <div className="order-container-overview mt-5" style={{zIndex: 1000 / (index + 1)}}>
            {/* shipment count */}

            <div className="d-flex align-items-center justify-content-between order-container-overview_shipment-count mb-2">
                <p className="font-body-md m-0 tw-p-0">Includes order(s):</p>
                <div className="m-0 tw-p-0 d-flex align-items-center justify-content-start">
                    <p className="m-0"> Shipment </p>
                    <h5 className="ps-2 font-body-md m-0">
                        {index + 1} of {ctx.shipments.length}
                    </h5>
                </div>
            </div>

            <div className="order-container-overview_shipments-included">
                {shipmentOrderIds.map(orderId => {
                    const order = ctx.orders?.find(({id}) => id === orderId);
                    let itemLabel =
                        order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN
                            ? order.product_type_label
                            : order.size_description;

                    const label = prettyProductLabel(itemLabel, order.product_type_id);
                    const subLabel = prettyProductLabel(
                        order.graphic_design_order_details.product_label,
                        order.product_type_id
                    );

                    return (
                        <div key={order.id} className="shipments-included_shipment">
                            <div className="d-flex align-items-start justify-content-start">
                                <h5 className="me-3">{label}</h5>
                            </div>
                            <p>{subLabel.split(' ').at(-1)}</p>
                        </div>
                    );
                })}
            </div>

            <Banner className="bg-accent-secondary">
                This order is digital delivery or and will be delivered by mail
            </Banner>
        </div>
    );
};
